module.exports = {
	"data": {
		"postBySlug": {
			"html": "<h3 id=\"dmgt-manages-a-balanced-multinational-portfolio-of-entrepreneurial-companieswith-total-revenues-of-around-£15-billion-that-provide-a-diverse-range-of-businesses-and-consumers-with-compelling-information-analysis-insight-news-and-entertainment\"><a href=\"#dmgt-manages-a-balanced-multinational-portfolio-of-entrepreneurial-companieswith-total-revenues-of-around-%C2%A315-billion-that-provide-a-diverse-range-of-businesses-and-consumers-with-compelling-information-analysis-insight-news-and-entertainment\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>DMGT manages a balanced multinational portfolio of entrepreneurial companies,with total revenues of around £1.5 billion, that provide a diverse range of businesses and consumers with compelling information, analysis, insight, news and entertainment.</h3>\n<p></p>",
			"timeToRead": 1,
			"excerpt": "DMGT manages a balanced multinational portfolio of entrepreneurial companies,with total revenues of around £1.5 billion, that provide a...",
			"frontmatter": {
				"title": "1. DMGT at a glance ",
				"cover": null,
				"date": null,
				"category": null,
				"tags": null
			}
		},
		"tableOfContents": {
			"chapters": [
				{
					"title": "1. Main Chapter",
					"entries": null,
					"chapters": [
						{
							"title": "1.1 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_one.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/1-dmgt-at-a-glance"
											},
											"frontmatter": {
												"title": "1. DMGT at a glance "
											}
										}
									}
								}
							],
							"chapters": [
								{
									"title": "1.1.1 Sub-subchapter",
									"entries": [
										{
											"entry": {
												"id": "/opt/build/repo/content/lessons/lesson_two.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/lesson-two-scope-and-responsibilities"
													},
													"frontmatter": {
														"title": "Lesson Two - Scope and responsibilities"
													}
												}
											}
										},
										{
											"entry": {
												"id": "/opt/build/repo/content/lessons/lesson_three.md absPath of file",
												"childMarkdownRemark": {
													"fields": {
														"slug": "/lesson-three-code-of-conduct"
													},
													"frontmatter": {
														"title": "Lesson Three - Code of Conduct"
													}
												}
											}
										}
									]
								}
							]
						},
						{
							"title": "1.2 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_four.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/lesson-four"
											},
											"frontmatter": {
												"title": "Lesson Four"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "2. Main Chapter",
					"entries": null,
					"chapters": [
						{
							"title": "2.1 Subchapter",
							"entries": [
								{
									"entry": {
										"id": "/opt/build/repo/content/lessons/lesson_five.md absPath of file",
										"childMarkdownRemark": {
											"fields": {
												"slug": "/lesson-five"
											},
											"frontmatter": {
												"title": "Lesson Five"
											}
										}
									}
								}
							],
							"chapters": null
						}
					]
				},
				{
					"title": "3. Main Chapter",
					"entries": [
						{
							"entry": {
								"id": "/opt/build/repo/content/lessons/lesson_six.md absPath of file",
								"childMarkdownRemark": {
									"fields": {
										"slug": "/lesson-six"
									},
									"frontmatter": {
										"title": "Lesson Six"
									}
								}
							}
						}
					],
					"chapters": null
				}
			]
		}
	},
	"pathContext": {
		"slug": "/1-dmgt-at-a-glance"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/1-dmgt-at-a-glance.json
// module id = 399
// module chunks = 96637179027799